import ujs from "@rails/ujs"
import * as activestorage from "@rails/activestorage"

import "../util/axiosSetup"
import mountComponents from "../util/mountComponents"
import defaultColors from "../../../theme/colors.json"
import prepareColorVariables from "../util/prepareColorVariables"

ujs.start()
activestorage.start()

// Make all images available for image_pack_tag
require.context("../images", true)

// Add all component CSS files to bundle (required for components with no JS files)
require.context("../components", true, /(?<=\.scss)$/) // Only include scss files

// Add application wide CSS, we do this after the components
// because we want tailwind classes to override default component styling
require("../application.scss")

// Define CSS variables for all colors
// These variables are used by tailwind.
// We use variables because they are easy to override in dev tools or in local selectors
const cssRoot: HTMLElement | null = document.querySelector(":root")

const colors = "theme" in window ? window.theme : defaultColors
const cssVariables = prepareColorVariables(
  colors as prepareColorVariables.JsonColors
).cssVariables
Object.entries(cssVariables).forEach(([name, value]) =>
  cssRoot?.style.setProperty(name, value)
)

// Make components available for react_component helper
const componentsContext = require.context(
  "../components",
  true,
  /(?<!(test|test\.[jt]sx?|\.scss))$/ // Exclude tests and scss files
)
mountComponents(componentsContext)
